export default "__VITE_ASSET__BX36qv76__"